var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import customIcon from '../../assets/images/icons/common/icon-settings-gold.png';
import { DialogContext } from '../../context/dialog';
import { useInput } from '../../hooks/common/use-input';
import { DialogType } from '../../types/dialogs';
import Accordion from '../common/accordion';
import IconCheckbox from './icon-checkbox';
import NumberingCheckbox from './numbering-checkbox';
export default function NumberingForm(_a) {
    var value = _a.value, setValue = _a.setValue, custom = _a.custom, setCustom = _a.setCustom;
    var t = useI18n().t;
    var _b = useContext(DialogContext), dialogProps = _b.dialogProps, setDialogProps = _b.setDialogProps;
    var customNumberings = useInput(custom && value.length > 0 ? value.join(',') : '');
    var _c = useState(undefined), customError = _c[0], setCustomError = _c[1];
    useEffect(function () {
        setDialogProps((dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.custom.type) === DialogType.CUSTOM_NUMBERINGS
            ? {
                common: __assign(__assign({}, dialogProps.common), { actions: [
                        {
                            text: t('common.confirm'),
                            action: function () { return submitCustom(customNumberings.value); },
                            highlighted: true,
                            disabled: customNumberings.value.length === 0,
                        },
                    ] }),
                custom: {
                    type: DialogType.CUSTOM_NUMBERINGS,
                    value: customNumberings,
                    error: customError,
                },
            }
            : undefined);
    }, [customNumberings.value, customError]);
    function onChange(template) {
        setCustom(false);
        if (value.length + 1 === template) {
            setValue([]);
            return;
        }
        var _value = [];
        for (var i = 1; i < template; i++) {
            _value.push(i);
        }
        setValue(_value);
    }
    function showCustomDialog() {
        setDialogProps({
            common: {
                title: t('filters.custom-numberings.title'),
                close: { text: t('common.back'), action: closeCustomDialog },
                actions: [
                    {
                        text: t('common.confirm'),
                        action: function () { return submitCustom(customNumberings.value); },
                        highlighted: true,
                        disabled: customNumberings.value.length === 0,
                    },
                ],
            },
            custom: {
                type: DialogType.CUSTOM_NUMBERINGS,
                value: customNumberings,
                error: customError,
            },
        });
    }
    function submitCustom(text) {
        var splitted = text.split(',');
        if (splitted.length === 0) {
            setCustomError(t('error.invalid-input'));
            return;
        }
        var result = [];
        for (var _i = 0, splitted_1 = splitted; _i < splitted_1.length; _i++) {
            var elem = splitted_1[_i];
            var parsed = Number.parseInt(elem);
            if (isNaN(parsed) || parsed < 1) {
                setCustomError(t('error.invalid-input'));
                return;
            }
            result.push(parsed);
        }
        setDialogProps(undefined);
        setCustomError(undefined);
        setCustom(true);
        setValue(result);
    }
    function closeCustomDialog() {
        customNumberings.setValue('');
        setCustomError(undefined);
        setCustom(false);
        setDialogProps(undefined);
    }
    return (_jsx(Accordion, { count: value.length > 0 ? 1 : 0, defaultValue: true, height: 64, title: t('filters.numbering'), children: _jsxs(Container, { children: [_jsx(NumberingCheckbox, { hidden: value.length > 0 && (custom || value.length + 1 !== 10), label: "<10", noneSelected: value.length === 0, onChange: function () { return onChange(10); }, value: value.length + 1 === 10 && !custom }), _jsx(NumberingCheckbox, { hidden: value.length > 0 && (custom || value.length + 1 !== 50), label: "<50", noneSelected: value.length === 0, onChange: function () { return onChange(50); }, value: value.length + 1 === 50 && !custom }), _jsx(NumberingCheckbox, { hidden: value.length > 0 && (custom || value.length + 1 !== 100), label: "<100", noneSelected: value.length === 0, onChange: function () { return onChange(100); }, value: value.length + 1 === 100 && !custom }), _jsx(IconCheckbox, { hidden: value.length > 0 && !custom, icon: customIcon, onChange: showCustomDialog, value: custom })] }) }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-start;\n  padding: 0 24px;\n  width: 100%;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-start;\n  padding: 0 24px;\n  width: 100%;\n"])));
var templateObject_1;
